import { TFunction } from 'i18next';
import isNaN from 'lodash/isNaN';
import i18n from '../locales/i18n';
import { SalaryDisplayOption } from '../modules/administration/positionManagement/createJobs/JobPositionDetailCard';

export const isSalaryFixed = (minSalary: number, maxSalary: number) =>
  !isNaN(maxSalary) && !isNaN(minSalary) && (maxSalary <= minSalary || maxSalary === 0);

export const validateSalary = (
  inputValue: string,
  minSalary: number,
  maxSalary: number,
  isCountryAustralia: boolean,
  t: TFunction,
): { validatedSalary: string; error: string } => {
  const cleanedValue = inputValue.replace(/[^0-9.,]/g, '');
  const numericValue = Number(cleanedValue.replace(',', '.'));

  // in case of Australia, allow empty salary
  if (isCountryAustralia && cleanedValue.trim() === '') {
    return { validatedSalary: '', error: '' };
  }

  const isFixedSalary = isSalaryFixed(minSalary, maxSalary);

  // istanbul ignore next
  if (isFixedSalary && isCountryAustralia) {
    return {
      validatedSalary: cleanedValue,
      error:
        Number(cleanedValue) !== minSalary
          ? t('messaging:actions.hire.confirmationModal.fixedSalaryRangeError', {
              minSalary: minSalary.toFixed(2),
            })
          : '',
    };
  }

  if (isFixedSalary && !isCountryAustralia) {
    return { validatedSalary: minSalary.toFixed(2), error: '' };
  }

  if (cleanedValue !== '' && !isNaN(minSalary) && !isNaN(maxSalary) && maxSalary > minSalary) {
    if (numericValue < minSalary || numericValue > maxSalary) {
      return {
        validatedSalary: cleanedValue,
        error: t('messaging:actions.hire.confirmationModal.salaryRangeError', {
          minSalary: minSalary.toFixed(2),
          maxSalary: maxSalary.toFixed(2),
        }),
      };
    }
  }

  return { validatedSalary: cleanedValue, error: '' };
};

export const getSalaryDisplayText = (salaryType: string, minValue: string, maxValue: string, salaryUnit: string): string => {
  if (salaryType === SalaryDisplayOption.UP_TO) {
    return i18n.t('requisition:upToSalaryInfo', {
      maxSalary: `$${maxValue}`,
      salaryUnit,
    });
  }
  if (salaryType === SalaryDisplayOption.RANGE) {
    return i18n.t('requisition:rangeSalaryInfo', {
      minSalary: `$${minValue}`,
      maxSalary: `$${maxValue}`,
      salaryUnit,
    });
  }
  if (salaryType === SalaryDisplayOption.FIXED) {
    return i18n.t('requisition:fixedSalaryInfo', {
      minSalary: `$${minValue}`,
      salaryUnit,
    });
  }
  if (salaryType === SalaryDisplayOption.HIDDEN) {
    return i18n.t('requisition:hideSalaryInfo');
  }
  return i18n.t('requisition:startingAtSalaryInfo', {
    minSalary: `$${minValue}`,
    salaryUnit,
  });
};
